import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="discord"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.858 17.635 6.675 20c-1.507-.628-3.068-1.255-4.727-2.336a2.085 2.085 0 0 1-.944-1.707c-.072-3.542.76-7.104 2.865-10.87a2.331 2.331 0 0 1 1.267-1.042c1.27-.45 2.133-.799 3.61-1.045l.887 1.626S10.521 4.33 12 4.33c1.48 0 2.367.296 2.367.296L15.254 3c1.477.246 2.34.594 3.61 1.045.532.189.991.55 1.267 1.043 2.105 3.765 2.937 7.327 2.865 10.87a2.085 2.085 0 0 1-.944 1.706c-1.66 1.08-3.22 1.708-4.727 2.336l-1.183-2.365M6.083 16.452S9.042 17.93 12 17.93c2.958 0 5.916-1.478 5.916-1.478"
    />
    <path
      strokeWidth={2}
      d="M9.421 11.5c0 .515-.145.938-.326 1.203-.185.27-.338.297-.384.297-.047 0-.2-.027-.385-.297C8.145 12.438 8 12.015 8 11.5c0-.515.145-.938.326-1.203.185-.27.338-.297.385-.297.046 0 .199.027.384.297.181.265.326.688.326 1.203Zm6.579 0c0 .515-.145.938-.326 1.203-.185.27-.338.297-.384.297-.047 0-.2-.027-.385-.297-.181-.265-.326-.688-.326-1.203 0-.515.144-.938.326-1.203.185-.27.338-.297.385-.297.046 0 .199.027.384.297.181.265.326.688.326 1.203Z"
    />{" "}
  </svg>
);
export default SvgComponent;
